import React from 'react';
import { Button, Select, Table, Typography } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';

const data = [
  {
    key: "01",
    sno: "1",
    particulars: "Number of Beneficiary",
    sixmonthtothreemonth: "12344",
    sixmonthtothreemonthsam: "1234",
    sixyeartothreeyear: "1234",
    sixyeartothreeyearsam: "0987",
  },
  {
    key: "02",
    sno: "2",
    particulars: "S. Days",
    sixmonthtothreemonth: "25",
    sixmonthtothreemonthsam: "24",
    sixyeartothreeyear: "25",
    sixyeartothreeyearsam: "25",
  },
  {
    key: "03",
    sno: "3",
    particulars: "S. Qty.",
    sixmonthtothreemonth: "1.90",
    sixmonthtothreemonthsam: "2.90",
    sixyeartothreeyear: "2.90",
    sixyeartothreeyearsam: "23",
  },
  {
    key: "04",
    sno: "4",
    particulars: "Overall Ton",
    sixmonthtothreemonth: "25 Ton",
    sixmonthtothreemonthsam: "15 Ton",
    sixyeartothreeyear: "20 Ton",
    sixyeartothreeyearsam: "30 Ton",
  },
];

const months = [
  "JAN", "FEB", "MAR", "APR", "MAY", "JUNE", "JULY", "AUG", "SEP", "OCT", "NOV", "DEC"
];

const columns = [
  { title: <span style={{ fontWeight: 600 }}>S.no</span>, dataIndex: "sno", key: "sno", align: "center" ,},
  { title: <span style={{ fontWeight: 600 }}>Particulars</span>, dataIndex: "particulars", key: "particulars", align: "center" },
  { title: <span style={{ fontWeight: 600 }}>6m-3m</span>, dataIndex: "sixmonthtothreemonth", key: "sixmonthtothreemonth", align: "center" },
  { title: <span style={{ fontWeight: 600 }}>6m-3m Sam</span>, dataIndex: "sixmonthtothreemonthsam", key: "sixmonthtothreemonthsam", align: "center" },
  { title: <span style={{ fontWeight: 600 }}>3y-6y</span>, dataIndex: "sixyeartothreeyear", key: "sixyeartothreeyear", align: "center" },
  { title: <span style={{ fontWeight: 600 }}>3y-6y Sam</span>, dataIndex: "sixyeartothreeyearsam", key: "sixyeartothreeyearsam", align: "center" },
];

const RM_TabS = () => {
  const { month } = useParams();
  const navigate = useNavigate();

  return (
    <div style={{ background: "#f7f7fa", minHeight: "100vh", paddingTop: 30 }}>
      <div
        style={{
          width: "100%",
          background: "#fff",
          borderRadius: 18,
          boxShadow: "0 4px 18px rgba(60,64,67,0.08)",
          padding: 32,
          marginTop: 0,
        }}
      >
        {/* Header Info */}
        <div style={{ display: "flex", gap: 20, marginBottom: 22, alignItems: "center" }}>
          <Button type="link" style={{ color: "#434343", fontWeight: 700, fontSize: 17, cursor: "default" }} tabIndex={-1}>
            KTKKAR0825
          </Button>
          <Button type="link" style={{ color: "#434343", fontWeight: 700, fontSize: 17, cursor: "default" }} tabIndex={-1}>
            JUN 2025
          </Button>
          <Button type="link" style={{ color: "#434343", fontWeight: 700, fontSize: 17, cursor: "default" }} tabIndex={-1}>
            140000
          </Button>
          <Button
            style={{
              background: "#063253",
              color: "#fff",
              fontWeight: "bold",
              borderRadius: "7px",
              minWidth: "110px",
              height: "36px",
              fontSize: 16,
              boxShadow: "0 2px 8px #e0e0e0",
            }}
            tabIndex={-1}
          >
            Pushtii
          </Button>
        </div>

        {/* Select Dropdown */}
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 18 }}>
          <Typography.Text style={{ fontWeight: 500, color: "#232c29", fontSize: 15, marginRight: 6 }}>
            Select From Serving PD Master
          </Typography.Text>
          <Select
            style={{ width: 190, borderRadius: 8, fontSize: 15, background: "#fafafb" }}
            placeholder="Pushti - AUG"
            size="large"
            value={month}
            onChange={(value) => navigate(`/master/raw-material-planning/rm-tabs/${value}`)}
          >
            {months.map((m) => (
              <Select.Option key={m} value={m}>
                Pushti - {m}
              </Select.Option>
            ))}
          </Select>
        </div>

        {/* Table */}
        <div style={{ borderRadius: 13, overflow: "hidden", boxShadow: "0 1.5px 8px #e8eaf0" }}>
          <Table
            columns={columns}
            dataSource={data}
            pagination={false}
            bordered
           
          
          />
        </div>

        {/* Footer Button */}
        <div style={{ display: "flex", justifyContent: "center", marginTop: 22 }}>
          <Button
            style={{
              background: "#05622C",
              color: "#fff",
              borderRadius: "7px",
              minWidth: 150,
              minHeight: 38,
              fontWeight: 600,
              fontSize: 16,
              boxShadow: "0 1px 6px #c6eabf",
            }}
            onClick={() => navigate("/master/raw-material-planning/rm-calculation")}
          >
            Apply Formula
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RM_TabS;
